module.exports = __webpack_public_path__ + "534ca99fa38314317d356dfcccf65f5f.svg";